/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSpreadsheetConfigDto } from '../../models/backend-spreadsheet-config-dto';
import { BackendSpreadsheetConfigRequestDto } from '../../models/backend-spreadsheet-config-request-dto';

export interface SalesSpreadsheetUpdate$FormData$Params {
  id: number;
  body: BackendSpreadsheetConfigRequestDto;
}

export function salesSpreadsheetUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesSpreadsheetUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSpreadsheetConfigDto>> {
  const rb = new RequestBuilder(rootUrl, salesSpreadsheetUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSpreadsheetConfigDto>;
    }),
  );
}

salesSpreadsheetUpdate$FormData.PATH = '/api/sales/spreadsheet/{id}';
